<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'financialTransactions.export.title' | translate }}</h4>
      <p class="mb-0">{{ 'financialTransactions.export.text' | translate }}</p>
    </div>
    <div class="card-body">
      <div class="px-3">
        <form class="form" #financialTransactionsExportForm="ngForm"
              (ngSubmit)="onSubmit(financialTransactionsExportForm)">
          <div class="form-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="FromDate">{{ 'financialTransactions.export.fromDateFieldLabel' | translate }}</label>
                  <input class="form-control" name="FromDate" [(ngModel)]="fromDate" data-placement="top"
                         data-title="From Date" data-toggle="tooltip" data-trigger="hover" type="date">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="ToDate">{{ 'financialTransactions.export.toDateFieldLabel' | translate }}</label>
                  <input class="form-control" name="ToDate" [(ngModel)]="toDate" data-placement="top"
                         data-title="To Date" data-toggle="tooltip" data-trigger="hover" type="date">
                </div>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button class="btn btn-raised btn-raised btn-primary mr-1" type="submit"
                    [disabled]="!financialTransactionsExportForm.valid">
              <i class="ft-x-square"></i> {{ 'buttons.exportText' | translate }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
